import React, { useState, useEffect, useContext } from 'react';
import { Bell, Save } from 'lucide-react';
import axios from 'axios';
import Swal from 'sweetalert2';
import AppContext from '../../../../context/AppContext';
import '../../../../assets/css/customer/customerdashboard/customersettings/notificationssettings.css';

const NotificationSettings = () => {
  const { baseUrl, authToken } = useContext(AppContext);

  const [notifications, setNotifications] = useState({
    inAppNotifications: true
  });

  useEffect(() => {
    axios
      .get(`${baseUrl}/customer/get`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        const customer = response.data.data;
        setNotifications((prev) => ({
          ...prev,
          inAppNotifications: !!Number(customer.in_app_notifications),
        }));
      })
      .catch((error) => {
        console.log(error);
      });
  }, [baseUrl, authToken]);

  return (
    <div className="cus-notif-container">
      <div className="cus-notif-wrapper">
        <div className="cus-notif-page-header">
          <Bell size={28} className="cus-notif-header-icon" />
          <h2 className="cus-notif-page-title">Notification Settings</h2>
        </div>

        <div className="cus-notif-settings-card">
          <div className="cus-notif-card-header">
            <Bell size={24} className="cus-notif-card-icon" />
            <h4 className="cus-notif-card-title">Manage Your Notifications</h4>
          </div>

          <div className="cus-notif-section">
            <h6 className="cus-notif-section-title">In-app Notifications</h6>
            <p className="cus-notif-section-description">
              Receive notifications within the app about bookings, offers, and updates
            </p>

            <div className="cus-notif-toggle-item">
              <div className="cus-notif-toggle-info">
                <span className="cus-notif-toggle-label">Enable In-app Notifications</span>
                <span className="cus-notif-toggle-description">
                  Get instant notifications about your bookings, special offers, and important updates while using the app
                </span>
              </div>
              <div
                className={`cus-notif-toggle-switch ${notifications.inAppNotifications ? 'cus-notif-active' : ''}`}
                onClick={() =>
                  setNotifications(prev => ({ ...prev, inAppNotifications: !prev.inAppNotifications }))
                }
              >
                <div className="cus-notif-toggle-slider" />
              </div>
            </div>
          </div>

          <button
            className="cus-notif-save-button"
            onClick={() => {
              axios
                .post(
                  `${baseUrl}/customer/cus-notification-settings`,
                  {
                    in_app_notifications: notifications.inAppNotifications ? 1 : 0
                  },
                  {
                    headers: {
                      Authorization: `Bearer ${authToken}`
                    }
                  }
                )
                .then(response => {
                  Swal.fire('Success', response.data.message, 'success');
                })
                .catch(error => {
                  console.log(error);
                  Swal.fire('Error', 'Failed to save notification settings', 'error');
                });
            }}
          >
            <Save size={18} />
            Save Preferences
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationSettings;